export const all = () => {
    return [
        {
            key: "NEW",
            value: 1,
            label: 'Новый',
        },
        {
            key: "PENDING",
            value: 2,
            label: 'В ожидании',
        },
        {
            key: 'IN_PROCESS',
            value: 3,
        },
        {
            key: 'ON_SIGN',
            value: 4,
            label: 'На подписание',
        },
        {
            key: 'FINISH',
            value: 5,
            label: 'Резолюция закрыта',
        },
        {
            key: 'ON_DIRECTOR_SIGN',
            value: 6,
            label: 'На подписание у директора',
        },
    ]
}

export const getValueByKey = (key) => {
    return all().find(item => item.key === key)?.value
}

export default {
    all,
    getValueByKey
};